export const APP_INITIALIZATION = 'APP_INITIALIZATION' as const
export const APP_BECAME_VISIBLE = 'APP_BECAME_VISIBLE' as const

export const appInitialization = (): { type: typeof APP_INITIALIZATION } => ({
  type: APP_INITIALIZATION
})

export const appBecameVisible = (): { type: typeof APP_BECAME_VISIBLE } => ({
  type: APP_BECAME_VISIBLE
})
